import { forwardRef } from 'react';

import { AppPortal } from 'ui/Auth/portals';
import { useAppPortal } from 'ui/Auth/state/useAppPortal';

import { AppMenu } from './AppMenu';

interface Props {
  // If given, which app portal is currently active
  activeAppPortal?: AppPortal;
}

// Using forwardRef to allow third party components access to inner component
// https://reactjs.org/docs/forwarding-refs.html
export const MultiAppSwitcher: React.FC<Props> = forwardRef<HTMLLIElement, Props>(
  ({ activeAppPortal }, ref) => {
    const { availablePortalsInfo, getPortalPath } = useAppPortal(activeAppPortal);

    // All authenticated users are expected to have at least one allowed portal.
    // However, we don't need to render anything if there are no portals, which can happen if:
    //
    // 1. The user is not logged in
    // 2. The user is already using their only allowed portal
    // 3. The user has no allowed portals (technically possible, but shouldn't happen)
    if (!availablePortalsInfo.length) {
      return null;
    }

    return (
      <AppMenu
        forwardedRef={ref}
        switchablePortals={availablePortalsInfo.map((info) => ({
          ...info,
          path: getPortalPath(info.portal),
        }))}
      />
    );
  }
);
